const wifeRU = {
    chat: "<1>Разговаривая с {{wife}}</1>" +
        "<2/>" +
        "Вы в течение часа болтали с <3/> на разные темы.\n\n" +
        "<4>Продолжить</4>",
    makeOut: "<1>Целуясь с {{wife}}</1>" +
        "<2/>" +
        "<3>{{wife}}, у тебя что-то на губе, давай посмотрю...</3>" +
        "Ты страстно поцеловал жену.\n\n" +
        "<4>Продолжить</4>",
    busy: "<1>{{wife}}</1>" +
        "<2/>" +
        "<3>Что ты хочешь?</3>" +
        "<3>Нет, я занята сейчас, отстань!</3> (Повысь уровень отношений с <4/>)\n\n" +
        "<5>Отстать</5>",
    howSheFeels: {
        part1: "<1>{{wife}}</1>" +
            "<2/>" +
            "<3>Как дела? Как себя чувствуешь?</3>",
        part2: "<1>Нормально всё, я занята.</1>" +
            "Видимо, она не особо хочет со мной разговаривать. <2>Отношения > 22</2><3/><3/>" +
            "<4>Отойти от {{wife}}</4>",
        part3: "<1>Ну кстати не очень хорошо. Не знаю, что со мной, но какое-то слабое состояние и подташнивает.</1>" +
            "<2>Давай тогда я тебе принесу аспирин и поспи немного...</2>" +
            "<1>Да, наверное ты прав, нужно немного поспать.</1>" +
            "Ты принес <3/> таблетку аспирина, после чего накрыл ей одеялом и она уснула.\n\n" +
            "<4>Выйти из комнаты</4>",
        part4: "<1>Отлично всё, а что такое?</1>" +
            "<2>Ничего, просто удостоверился, что всё хорошо.</2><3/> посмотрела на тебя с непонимающим взглядом.\n\n" +
            "<4>Отойти от {{wife}}</4>"
    },
    watchPorn: "<1>Что? Какая гадость, даже не подумаю... Что это со мной сегодня...</1>" +
        "<2>Недоступно в данной версии.</2><3/><3/>" +
        "<4>Отойти</4>",
    bathTogether: "<1>Мне кажется, ты забыла про меня, малышка.</1>" +
        "<2>Ну если тебе так кажется, то давай, залезай сюда, ковбой.</2><3/>" +
        "Вы приняли душ вместе." +
        "<4/><3/><3/>" +
        "<5>Одеваться</5>",
    bathTogetherDeny: "<1>{{player}}, что ты хочешь? Отстань от меня, я в душе!</1>" +
        "Ей не очень понравилась твоя идея." +
        "<2>Отношения > {{conditions}}</2><3/>" +
        "<4>Назад</4>",
    checkHerAssFailure: "Перед тем, как приподнять одеяло, ты немного постоял над <1/> чтобы понять, спит ли она. Вроде бы спала. " +
        "Тогда ты начал медленно приподнимать одеяло и, когда ты был на середине, ты услышал её голос:" +
        "<2>{{player}}, что ты делаешь?</2>" +
        "<3>Я... ничего... Проверял, укрыта ли ты...</3>" +
        "<2>Я сплю, отстань от меня.</2>" +
        "<3>Хорошо... прости.</3>Нужно бы подобрать для этого более подходящий момент." +
        "<4>(На самом деле нет, достаточно повысить отношения. Relations > {{relations}})</4><5/><5/>" +
        "<6>Отойти</6>",
    checkHerAssSuccess: "Перед тем, как приподнять одеяло, ты немного постоял над <1/> чтобы понять, спит ли она. Вроде бы спала. " +
        "Тогда ты начал медленно приподнимать одеяло и, когда ты был на середине, она немного дернулась, но продолжила спать.\n" +
        "\"Фух, пронесло.\" - подумал ты и продолжил тянуть одеяло вверх.\n" +
        "Тебе представилась великолепная картина:" +
        "<2/><3/><3/>" +
        "<4>Ощутить её задницу (недоступно в текущей версии)</4><3/>" +
        "<5>Отойти</5>",
    handsJob: "<1>Работа руками...</1>" +
        "<2/>" +
        "<3>Фу, какая гадость, не за что не буду трогать его руками!</3>" +
        "<4>Недоступно в данной версии</4><5/><5/>" +
        "<6>Отойти</6>",
    blowjob: "<1>Работа ртом...</1>" +
        "<2/>" +
        "<3>Даже не проси меня об этом! Ни-ког-да, понял???</3>" +
        "<4>Недоступно в данной версии</4><5/><5/>" +
        "<6>Отойти</6>",
    sexNegative: "<1>Секс...</1>" +
        "<2/>" +
        "<3>{{player}}, отстань от меня, ты не видишь, что я занята???</3>" +
        "<4>Не приставай к ней, пока не повысишь отношения. Relations > {{relations}}</4><5/><5/>" +
        "<6>Отойти</6>",
    sexNo: "<1>Секс...</1>" +
        "<2/>" +
        "<3>{{player}}, я не хочу секса, понимаешь? Бывает иногда такое, что просто не хочется...</3>" +
        "<4>Повысь еще немного отношения с ней... Relations > {{relations}}</4><5/><5/>" +
        "<6>Отойти</6>",
    sexYes: "<1>Секс...</1>" +
        "Ты начал медленно целовать губы <2/>, опускаясь всё ниже, руки зацепили её кофту и начали медленно стягивать её." +
        "<3>Подожди, давай, пожалуйста, занавесим шторы, мне некомфортно...</3>Сказала <2/>, останавливая тебя." +
        "<4>Хорошо, если тебе так будет спокойнее.</4>Ты попытался не выдать своё раздражение из-за глупой просьбы жены.\n" +
        "После того, как шторы были занавешены, ты стянул с <2/> кофту и продолжил нежно целовать её в шею." +
        "<5/>" +
        "<4>Я не могу ждать, готов тебе вставить прямо сейчас!</4>Сказал ты страстно." +
        "<3>Малыш, давай, пожалуйста, не так быстро... Мне нужно немного времени...</3>" +
        "<4>Хорошо, малышка.</4>Снова скрывая недовольство сказал ты и продолжил целовать её." +
        "<4>Ты же знаешь, как я тебя люблю?</4>" +
        "<3>Да, но давай без слов, пожалуйста, ты меня сбиваешь.</3>" +
        "Ты молча продолжил целовать её в шею, потом опустился ниже, приподнял футболку и начал целовать живот.\n" +
        "<2/> лежала с закрытыми глазами. В принципе, как и всегда. В вашей паре всё делал ты.\n" +
        "Через несколько мгновений ты стянул с неё футболку и продолжил целовать её." +
        "<6/>" +
        "Она всё так же лежала с закрытыми глазами. Единственное, что изменилось - её дыхание стало чаще.\n" +
        "Ты еще какое-то время продолжил целовать её живот, потом ребра, потом приподнял её и стянул лифчик." +
        "<7/>" +
        "Перед тобой открылся шикарный вид на грудь жены. Не теряя не секунды, ты опустил её на кровать и впился губами в её нежные соски, руками массируя её грудь. " +
        "При этом вздохи <2/> значительно участились. Ты чувствовал напряжение, в которое пришел твой член и не мог уже терпеть: одной рукой начал снимать с себя штаны, другой всё так же массируя грудь жены.\n" +
        "Когда член был выпущен на волю, ты отстал от её груди и максимально приблизился своим членом к её вагине. Она заметила это." +
        "<3>{{player}}, на мне ещё трусы...</3>" +
        "<4>Я знаю, детка, но я так возбужден, что готов выебать тебя и с ними.</4>" +
        "<3>Следи за словами, {{player}}! Не потерплю этих поганых слов.</3>Сказала она, прикрыв грудь руками." +
        "<3>И трусы нужно снять, не хочу их запачкать...</3>" +
        "\"Что за женщина? Настоящая убийца оргазма\" - Досадно подумал ты, но член даже и не думал опускаться, как будто говоря тебе " +
        "\"Да, это не очень сексуально, но мне уже похер.\" Ты стянул с неё трусы и начал ласкать её киску. " +
        "<8/>" +
        "Ты видел, что она вся аж извивается от твоих прикосновений, но ни стона и ни фразы так и не произнесла." +
        "<4>Тебе хорошо?</4>" +
        "<3>Да... Очень... Можешь... Войти в меня...</3>" +
        "Тебе только это и требовалось. Тогда ты окончательно снял с себя всю одежду и нежно вставил ей член. " +
        "Для этого она легла на спину и немного раздвинула ноги в сторону.\n" +
        "<2/> от удовольствия прикусила кулак, но ни звука так и не издала." +
        "<9/>" +
        "Ты ощутил, как идеально зашел твой член. Было ощущение, что именно для него была создана эта вагина, было даже немного тесно." +
        "Но после первого захода влагалище постепенно разработалось и вот ты уже во весь темп делал поступательные движения к своей жене." +
        "Минут через пять после начала действия ты решил поменять положение, поэтому вышел из жены попытался перевернуть её к себе спиной." +
        "<3>Ты... чего... делаешь?</3>Тяжело дыша спросила она." +
        "<4>Хочу поменять положение.</4>Ответил ты." +
        "<3>Нет! Я же говорила, что мне неприятно, когда я к тебе спиной, так что давай без своих штучек.</3>" +
        "Резко сказала она, перестав поддаваться тебе и оставшись лежать на спине. Ты вздохнул." +
        "<4>Хорошо...</4>" +
        "Ты снова стал раздраженный, но попытался скрыть это. В любом случае через несколько мгновений ты снова вставил свой член жене.\n" +
        "Минут через пять ты готов был кончить." +
        "<4>Сейчас кончу... Мммм...</4>" +
        "<3>Только не в меня!</3>Вскрикнула <2/> и резко отпрыгнула от тебя.\n" +
        "Ты уже не мог сдерживаться, поэтому кончил, куда пришлось." +
        "<10/>" +
        "Ты кончил на <2/>, потом выдохнул и хотел потянуться её поцеловать, но она уже начала вставать." +
        "<3>Посмотри, какой бардак ты тут устроил!</3>Сказала <11/>, вставая с кровати." +
        "<3>Пойду в душ.</3>Ты рухнул на кровать и пролежал так полчаса.\n\n" +
        "<12>Встать и пойти в душ</12>",
    analSex: "<1>Анальный секс...</1>" +
        "<2/>" +
        "<3>Даже не начинай!!!</3>" +
        "<4>Недоступно в данной версии</4><5/><5/>" +
        "<6>Отойти</6>"
};

export default wifeRU;